// Kalenderdatum als 'yyyy-MM-dd' uit de LOKALE datumdelen — voor dagvelden die de backend met de zone
// van domain/project omrekent naar een moment (bv. Access.EndDay = laatste dag mét toegang, zie zone-day).
// NIET toISOString(): de datepicker (MomentDateAdapter) levert lokale middernacht, en toISOString()
// rekent die om naar UTC — in elke tijdzone oostelijk van UTC wordt dat de vórige dag (bv. 5 okt
// 00:00 CEST → '2026-10-04T22:00:00Z'), waardoor een gekozen einddatum een dag te vroeg ingaat.
export function toDateOnlyString(value: Date | { toDate(): Date } | null | undefined): string | null {
    if (!value) return null;

    // Moment (MomentDateAdapter) heeft toDate(); een gewone Date niet.
    const __date = value instanceof Date ? value : value.toDate();
    if (isNaN(__date.getTime())) return null;

    const __month = String(__date.getMonth() + 1).padStart(2, '0');
    const __day = String(__date.getDate()).padStart(2, '0');
    const __year = String(__date.getFullYear()).padStart(4, '0');
    return `${__year}-${__month}-${__day}`;
}
